<template>
  <div>
    <hr class="mx-2" />
    <div class="px-2 pt-2 font-weight-bold text-uppercase">GARANTÍA</div>
    <validation-observer ref="job-warranty-form">
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col sm="12" md="6">
            <b-form-group
              label="Fecha inicio garantía"
              label-for="job-warranty"
            >
              <b-form-datepicker
                :value="model.warranty_start_date"
                class="margin-right-datepicker"
                size="sm"
                reset-button
                :hide-header="true"
                placeholder="Fecha inicio garantía"
                @input="update('warranty_start_date', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group
              label="Duración en meses"
              label-for="job-warranty-duration"
            >
              <v-select
                :value="model.warranty_duration"
                :options="warrantyDurationOptions"
                label="name"
                :reduce="(item) => item.value"
                @input="update('warranty_duration', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-checkbox
              :checked="model.without_warranty"
              :value="1"
              :unchecked-value="0"
              class="my-2"
              @input="update('without_warranty', $event)"
            >
              Sin garantía
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import FormMixin from "@/mixins/formMixin";

export default {
  name: "JobWarrantyForm",
  mixins: [FormMixin],
  data() {
    return {
      warrantyDurationOptions: [
        { name: "12 meses", value: 12 },
        { name: "18 meses", value: 18 },
        { name: "24 meses", value: 24 },
        { name: "36 meses", value: 36 },
        { name: "48 meses", value: 48 },
      ],
    };
  },
};
</script>
